import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { AdsGETApiAuth, AdsPUTApi } from "../../../Constant/api";
import { slugs } from "../../../Constant/slugs";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.id,
    sortable: true,
    reorder: true,
    width: "100px"
  },
  {
    id: 31,
    name: "Title",
    selector: (row) => row.title.rendered,
    sortable: true,
    reorder: true,
    width: "200px"

  },
  {
    id: 32,
    name: "Exam Time",
    selector: (row) => row.meta.exam_time,
    sortable: true,
    reorder: true
  },
  {
    id: 33,
    name: "Availability",
    selector: (row) => row.meta.available_unavailable,
    sortable: true,
    reorder: true,
    width: "150px"
  },
  // {
  //   id: 34,
  //   name: "Type",
  //   selector: (row) => row.meta.exam_sub_type,
  //   sortable: true,
  //   reorder: true
  // },
  {
    id: 34,
    name: "Category",
    selector: (row) => row.meta.exam_category,
    sortable: true,
    reorder: true
  },
  {
    id: 3,
    name: "View",
    cell: (row) => <Link to={`${slugs.exam_details}${row.slug}`}>View</Link>,

  }
];

export default function AllExam() {
  const [Projects1, setProjects1] = React.useState([])
  const [Projects2, setProjects2] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Available, setAvailable] = React.useState(0)
  const [UnAvailable, setUnAvailable] = React.useState(0)
  const [deleteUsersModal, setDeleteUsersModal] = React.useState(false)
  const [ExamCategoryList, setExamCategoryList] = React.useState([])
  const [choose, setChoose] = React.useState(0)

  const [Reload, setReload] = React.useState(false)
  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, slugs.db_slug_paid_exam)
      .then((res) => {
        setProjects2(res.data)
        setCustomersList(res.data)
        setAvailable(res.data.filter(a => a.meta.available_unavailable == "Available").length)
        setUnAvailable(res.data.filter(a => a.meta.available_unavailable == "Unavailable").length)
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }

  const typeArray = {
    "ubt": "UBT",
    "chapter-exam": "Chapter",
    "question-bank": "Question Bank",
    "weekly-test": "Weekly Test",
    "grammer-test": "Grammer Test"
  }
  const location = useLocation()
  const GetProject = (type) => {
    GetAllProjects({
      per_page: 1000,
      _fields: "id,title,slug,date,meta.exam_time,meta.available_unavailable,meta.exam_type,meta.exam_price,meta.exam_sub_type,meta.exam_category",
      "filter[meta_query][1][key]": "exam_type",
      "filter[meta_query][1][value][0]": `${typeArray[type]}`,
      "filter[meta_query][1][compare]": "=",
    })
  }
  const history = useHistory()
  var type;
  type = location.pathname.slice(slugs.all_exam.length + 1) == "" ? "ubt" : location.pathname.slice(slugs.all_exam.length + 1)

  useEffect(() => {
    var type;
    type = location.pathname.slice(slugs.all_exam.length + 1) == "" ? "ubt" : location.pathname.slice(slugs.all_exam.length + 1)
    GetProject(type)
    ExamCategoryListFetch()
    return history.listen((location) => {
      if (location.pathname.includes(slugs.all_exam)) {
        type = location.pathname.slice(slugs.all_exam.length + 1) == "" ? "ubt" : location.pathname.slice(slugs.all_exam.length + 1)
        window.scrollTo(0, 0)
        GetProject(type)
        ExamCategoryListFetch()
      }
    })
  }, [])
  var type = location.pathname.slice(slugs.all_exam.length + 1) == "" ? "ubt" : location.pathname.slice(slugs.all_exam.length + 1)
  const ExamCategoryListFetch = () => {
    AdsGETApiAuth(
      { per_page: 100, _fields: "id,title" },
      slugs.db_slug_exam_category
    )
      .then((res) => {
        setExamCategoryList(res.data)
      })
      .catch(e => {
        console.log(e)
      })
  }

  return (
    <div style={{}}>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Exam</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Exams
        </div>
      </div>
      <a href={`${slugs.new_exam}/${type}`}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
          onClick={() => {

          }}
        >Add New Exam</div>
      </a>
      <div className="row" >
        <div style={{ display: "inline", cursor: "pointer" }}>
          <div style={{
            display: "inline-block", margin: "0px 5px",
            // fontWeight: CustomersList.length == Projects2.length ? "bold" : "400"
          }}
            onClick={() => {
              setChoose(0)
              setProjects2(CustomersList)
            }}
          >
            All ({CustomersList.length}) |
          </div>
          <div style={{
            display: "inline-block", margin: "0px 5px",
            // fontWeight: CustomersList.filter(a => a.meta.available_unavailable == "Available").length == Projects2.length ? "bold" : "400"
          }}
            onClick={() => {
              setChoose(0)
              setProjects2(CustomersList.filter(a => a.meta.exam_sub_type == "Free"))
            }}
          >
            Free ({CustomersList.filter(a => a.meta.exam_sub_type == "Free").length}) |
          </div>
          <div style={{
            display: "inline-block", margin: "0px 5px",
          }}
            onClick={() => {
              setChoose(1)
              // setProjects2(CustomersList.filter(a => a.meta.available_unavailable == "Unavailable"))
            }}
          >
            Categories ({ExamCategoryList.length}) |
          </div>
          {Projects1.filter(a => a.meta.available_unavailable == "Unavailable").length !== 0 &&
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                for (let i = 0; i < Projects1.length; i++) {
                  setReload(true)
                  AdsPUTApi({
                    meta: {
                      "exam_sub_type": "",
                    }
                  }, slugs.db_slug_paid_exam, Projects1[i].id)
                    .then(res => {
                      if (i == Projects1.length - 1) {
                        setProjects1([])
                        GetProject(type)
                      }
                    })
                }
              }
              }
            >
              Cancel Free Exam |
            </div>
          }
          {Projects1.filter(a => a.meta.available_unavailable == "Available").length !== 0 &&
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                for (let i = 0; i < Projects1.length; i++) {
                  setReload(true)
                  AdsPUTApi({
                    meta: {
                      "exam_sub_type": "Free",
                    }
                  }, slugs.db_slug_paid_exam, Projects1[i].id)
                    .then(res => {
                      if (i == Projects1.length - 1) {
                        setProjects1([])
                        GetProject(type)
                      }
                    })
                }
              }
              }
            >
              Make Free Exam
            </div>
          }
          <div style={{ display: "inline-block", margin: "0px 5px" }}
            onClick={() => {
              setDeleteUsersModal(true)
            }}
          >
            Delete Selected |
          </div>
        </div>
      </div>

      <div style={{ backgroundColor: "#fff", padding: "10px", width: "98%", margin: "10px", border: "3px solid #eee" }}>
        {choose == 0 &&
          <DataTable
            paginationPerPage={100}
            paginationRowsPerPageOptions={[10, 50, 100, 1000]}
            columns={columns}
            data={Projects2}
            defaultSortFieldId={1}
            defaultSortAsc={false}
            striped
            // sortIcon={<SortIcon />}
            pagination
            selectableRows
            onSelectedRowsChange={(r) => {
              console.log("asdasd", r)
              setProjects1(r.selectedRows)
            }}
          />
        }
        {choose == 1 &&
          <table>
            <tr>
              <td>Category</td>
              <td>Total Exam</td>
              <td>Choose</td>
            </tr>
            {ExamCategoryList.map((item, index) => (
              <tr key={index}>
                <td>{item.title.rendered}</td>
                <td>{CustomersList.filter(a => a.meta.exam_category == item.title.rendered).length}</td>
                <td
                  onClick={() => {
                    setProjects2(CustomersList.filter(a => a.meta.exam_category == item.title.rendered))
                    setChoose(0)
                  }}

                >Choose</td>
              </tr>
            ))}

          </table>

        }

      </div>

      {deleteUsersModal &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setDeleteUsersModal(false)
                  }}
                >X</div>
                Do you really want to Delete all the Exam?<br />
                <div className="row">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setDeleteUsersModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div className="col-3 center">
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        for (let i = 0; i < Projects1.length; i++) {
                          setReload(true)
                          setDeleteUsersModal(false)
                          AdsPUTApi({
                            status: "draft"
                          }, slugs.db_slug_paid_exam, Projects1[i].id)
                            .then((res) => {
                              if (i == Projects1.length - 1) {
                                GetProject(type)
                              }
                            })
                            .catch((err) => {
                              console.log(err)
                            })

                        }
                      }}
                    >
                      Delete all Selected Exam
                    </div>
                  </div>
                </div>
                <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <DataTable
                    paginationPerPage={100}
                    paginationRowsPerPageOptions={[10, 50, 100, 1000]}
                    columns={columns}
                    data={Projects1}
                    defaultSortFieldId={1}
                    defaultSortAsc={false}
                    striped
                    // sortIcon={<SortIcon />}
                    pagination
                    selectableRows={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

      }
      {
        Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div >
  )
}